<ng-container
  *ngIf="{
    request: request$ | async,
  } as content"
>
  <div class="modal-report-history-details">
    <div class="grid-items">
      <p>
        <span class="title">{{ 'paymentHistory.yourPayment' | cxTranslate }}:</span>
        <span class="value">{{ data?.item?.yourPayment }}</span>
      </p>

      <p>
        <span class="title">{{ 'paymentHistory.receiptDate' | cxTranslate }}:</span>
        <span class="value">{{ data?.item?.receiptDate | cxDate: 'MM/dd/yyyy' }}</span>
      </p>

      <p>
        <span class="title">{{ 'paymentHistory.paymentAmount' | cxTranslate }}:</span>
        <span class="value">{{ data?.item?.paymentAmount?.formattedValue }}</span>
      </p>

      <p>
        <span class="title">{{ 'paymentHistory.appliedAmount' | cxTranslate }}:</span>
        <span class="value">{{ data?.item?.appliedAmount?.formattedValue }}</span>
      </p>
    </div>

    <div class="container-table m-t-20">
      @if (!content.request?.isPristine) {
        @if (!content.request?.isLoading) {
          @if (!content.request?.hasError) {
            <div class="content-container">
              @if (content.request?.table?.length) {
                <table-pro [configs]="tableConfig">
                  <table class="table-responsive table-md">
                    <thead>
                      <tr>
                        <th>{{ 'paymentHistory.invoiceDate' | cxTranslate }}</th>
                        <th>{{ 'paymentHistory.appliedAmount' | cxTranslate }}</th>
                        <th>{{ 'paymentHistory.discountTaken' | cxTranslate }}</th>
                        <th>{{ 'paymentHistory.dateApplied' | cxTranslate }}</th>
                        <th>{{ 'paymentHistory.amountDueRemaining' | cxTranslate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of content.request?.table">
                        <td [attr.data-value]="item.invoiceDate">
                          <span class="responsive-title"> {{ 'paymentHistory.invoiceDate' | cxTranslate }}: </span>

                          {{ item.invoiceDate | cxDate: 'MM/dd/yyyy' }}
                        </td>

                        <td [attr.data-value]="item.appliedAmount?.value">
                          <span class="responsive-title"> {{ 'paymentHistory.appliedAmount' | cxTranslate }}: </span>

                          {{ item.appliedAmount?.formattedValue }}
                        </td>

                        <td [attr.data-value]="item.discountTaken?.value">
                          <span class="responsive-title"> {{ 'paymentHistory.discountTaken' | cxTranslate }}: </span>

                          {{ item.discountTaken?.formattedValue }}
                        </td>

                        <td [attr.data-value]="item.dateApplied">
                          <span class="responsive-title"> {{ 'paymentHistory.dateApplied' | cxTranslate }}: </span>

                          {{ item.dateApplied | cxDate: 'MM/dd/yyyy' }}
                        </td>

                        <td [attr.data-value]="item.amountDueRemaining?.value">
                          <span class="responsive-title"> {{ 'paymentHistory.amountDueRemaining' | cxTranslate }}: </span>

                          {{ item.amountDueRemaining?.formattedValue }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </table-pro>
              } @else {
                <p class="ff-bold text-center">{{ 'paymentHistory.noContent' | cxTranslate }}</p>
              }
            </div>

            <div class="actions m-t-12">
              <button type="button" class="btn btn-primary btm-sm" (click)="close()">{{ 'paymentHistory.close' | cxTranslate }}</button>
            </div>
          } @else {
            <alert [alert]="alertDanger"></alert>
          }
        } @else {
          <local-loader></local-loader>
        }
      }
    </div>
  </div>
</ng-container>